import React, { Component } from 'react'
import { Grid, Button, Icon, Loader } from 'semantic-ui-react'
import InputField from '../../formComponents/inputField'
import { DropDown } from '../../formComponents/dropDown'
import * as actionCreators from '../../actions'
import {checkIfAlreadyApplied, checkIfRussiaTarriffAlreadyApplied, russiaTarriffCodes} from '../../actions/DescriptionOfMerchandiseActions'
import DutyItems from './DutyItems'
import { connect } from 'react-redux'
import { createMerchandiseDutyItem } from '../../api/createItem'
import SelecTextField from '../../formComponents/selectTextField'
import { displayMasterItem, displayDropDownItem } from '../util'
import PGAItems from '../pga/PGAItems'
import Warning from '../Warnings/Warning'
import _ , {get} from 'lodash'
import store from '../../store'
import PopUpIcon from '../../formComponents/PopUpIcon'
import AVCVDSection from '../../formComponents/avcvdSection'
import { DoMFields } from '../../util/supportedFields/descriptionOfMerchandise'
import { HttpClient } from "./../../../apiCalls/httpClient";
import PscLineItemReason from '../lineReason';
import {changeCountryOfOrigin,fetchSelectedReasonCodes} from "../../util";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { hasanyoverrideflag } from './DutyItem'
import { propsAreEqual_NoRerenderNeeded } from '../../reducer/util'
import { saveDescriptionOfMerchandiseLineItem } from '../../api/setFormData'
import UpdateTariffs from '../UpdateTariffs'

class MerchandiseLineItem_co extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isDeleting: false,
      isDutyAdding: false,
      formInfo: {},
      mystate: store.getState(),
      brokerId: props.brokerId,
      midList_bv: [],
      showMidList: false
    }
    for (let key in DoMFields) {
      DoMFields[key].errors = []
      DoMFields[key].valid = []
    }
    this.addErrorClass.bind(this)
    this.removeErrorClass.bind(this)
    this.validateField.bind(this)
  }
  
  // Check field Validity
  validateField(lineItemIndex, fieldName, value) {
    // let warning = 0
    const newState = Object.assign({}, this.state)
    newState.formInfo[fieldName] = value
    this.setState(newState)
    DoMFields[fieldName].errors = []
    DoMFields[fieldName].valid = true
    if (
      DoMFields[fieldName].rules &&
      DoMFields[fieldName].rules.length > 0
    ) {
      DoMFields[fieldName].rules.forEach(rule => {
        console.log("resttesttest",rule.test(value))
        if (!rule.test(value)) {
          DoMFields[fieldName].errors.push(rule.message)
          DoMFields[fieldName].valid = false
        }
      })
    }
    // Object.keys(DoMFields).forEach(field => {
    //   if (!DoMFields[field].valid) {
    //     warning++
    //   }
    // })
    // this.props.updateDOMErrorWarning(warning)
    if (DoMFields[fieldName].errors.length) {
      this.addErrorClass(lineItemIndex + fieldName, DoMFields)
    } else {
      this.removeErrorClass(lineItemIndex + fieldName, DoMFields)
    }
  }
  addErrorClass(fieldName, fieldType) {
    const inputField = document.getElementById(fieldName + window.shipmentId)
    inputField.classList.add('errorInput')
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId)
      if(inputField){
        inputField.classList.remove('errorInput')
      }
    } catch (e) {
      console.error(e)
    }
  }
  updateDeleteStatus = () => {
    this.setState({
      isDeleting: false
    })
  }

  dutyAddStatus = () => {
    this.setState({
      isDutyAdding: false
    })
  }

  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;

    return !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !propsAreEqual_NoRerenderNeeded(this.state,nextState);

  }

  displayWeightInkg = (unit, weight) => {
    if (unit === 'LB') {
      return (
        <span
          style={{
            fontStyle: 'italic',
            fontSize: '12px',
            position: 'absolute'
          }}
        >
          Weight in KG : {(parseFloat(weight) * 0.453592).toFixed(2)}
        </span>
      )
    }
  }
  hasADCVD = (merchandiseId) => {
    if(!this.state.mystate.DescriptionOfMerchandise)return false;
    
    var mymerch = this.state.mystate.DescriptionOfMerchandise.merchandiseLineItems.filter(lineitem => lineitem.merchandiseId == merchandiseId);
  //  console.log('mymerch: ', mymerch);
    if(mymerch.length != 1)return false;
    var myduty = mymerch[0].merchandiseDuties.filter(objj => objj.isCommodityDuty == 1);
 //   console.log('myduty: ', myduty);
    //.hsDataDtl.adCvdApplicable == 2
    if(myduty.length !=1) return false;
    return myduty[0].hsDataDtl.adCvdApplicable == 1;
    
  }

  enableDisableFrom = (enableLineItem) => {
    this.setState({
      "enableLineItem": enableLineItem
    })
  }
  componentDidMount(){
    const {
      lineItemIndex,invoiceItemIndex,
      updateMerchLineItemFeild,
      saveDescriptionOfMerchandiseLine,
      manufacturerHeaderIdUnderPartiesTab,
      deprecatedManufacturerId,
      headerParties,
      grossWeightUnits,
      updateMerchLineItemObject,
    } = this.props;
    let manufacturerParties = (headerParties || []).filter((a)=>a.headerPartyType=="MANUFACTURER");
    let manfacturerFromPartyTab = (manufacturerParties || []).filter((a)=>a.headerId==manufacturerHeaderIdUnderPartiesTab).pop();

    let missingdeprecatedid = !deprecatedManufacturerId && manfacturerFromPartyTab && manfacturerFromPartyTab.mId;
    let missingeitherid = !((manfacturerFromPartyTab||{}).value || deprecatedManufacturerId) && manufacturerParties &&manufacturerParties.length ==1;
    if( missingdeprecatedid){
      this.changemanufacturer(manfacturerFromPartyTab.mId,manufacturerParties)
    } else if(missingeitherid){
      this.changemanufacturer(manufacturerParties[0].mId,manufacturerParties);
    }
    else if(manufacturerParties.length == 1 && !manfacturerFromPartyTab && manufacturerHeaderIdUnderPartiesTab && deprecatedManufacturerId) {
      this.changemanufacturer(manufacturerParties[0].mId, manufacturerParties);
    }
    else if(manufacturerParties.length == 1 && !manufacturerHeaderIdUnderPartiesTab && deprecatedManufacturerId) {
      this.changemanufacturer(manufacturerParties[0].mId, manufacturerParties);
    }
    if(grossWeightUnits == '_BLANK_' || grossWeightUnits == 'None'){
      updateMerchLineItemObject(
        lineItemIndex,invoiceItemIndex,
        'grossWeight',
        'weightUnits',
        'KG'
      )

    }
    
  }
  changemanufacturer (value,manufacturerParties) {
    const {
      lineItemIndex,invoiceItemIndex,
      updateMerchLineItemFeild,
      saveDescriptionOfMerchandiseLine,
      handleLineItemContextSwitch,
    } = this.props;
    if(typeof value === 'object'){
      window.alert("Failed to select manufacturer. Manufacturer ID may be missing for this manufacturer. Check the manufacturer party");
      return;
    }
    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
      this.props.updateFormState("manufacturerId", value, "0", null)
      return;
    }
    setTimeout(()=>{
      document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
    },50)
    let mymann = manufacturerParties.filter((a)=>a.mId==value)[0];
    updateMerchLineItemFeild(
      lineItemIndex,invoiceItemIndex,
      "manufacturerId",
      value
    );
    mymann &&  updateMerchLineItemFeild(
      lineItemIndex,invoiceItemIndex,
      "manufacturerHeaderIdUnderPartiesTab",
      mymann.headerId
    );
    handleLineItemContextSwitch(lineItemIndex , invoiceItemIndex)
    saveDescriptionOfMerchandiseLine(
      lineItemIndex,invoiceItemIndex,
      'manufacturerId'
    )
  }

  render() {
    let {
       itDate,
      entryDate,
      countryList,
      updateMerchLineItemFeild,
      updateMerchLineItemObject,
      lineItemIndex,
      commercialDescription,
      countryOfOrigin,
      permitTypeCode,
      permitNumber,
      productClaimCode,
      saveDescriptionOfMerchandiseLine,
      clearDescriptionOfMerchandiseLine,
      saveMerchDutyItem,
      merchandiseId,
      IRTax,
      mpfFee,
      hmfFee,
      otherFee,
      totalLineItems,
      manufacturerHeaderIdUnderPartiesTab,
      grossWeightUnits,
      grossWeightWeight,
      splProgramList,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      charges,
      updateMerchFeild,
      addUserFee,
      saveMerchandiseField,
      updateMerchDutyItemFeild,
      updateMerchDutyItemObject,
      updateTotalValueAndGrossWeight,
      handleLineItemContextSwitch,
      deprecatedManufacturerId,
      removeMerchandiseLineItem,
      updateMerchLineItemPgaObject,
      //updateTotals,
      availableProductClaimCode,
      createPGA,
      isDisabled,
      // userFee actions
      userFeeCodes,
      userFees,
      removeUserFee,
      excemptUserFee,
      updateUserFee,
      // permit types/certificates
      permitTypeCodesList,
      isAdCvdApplicable,
      hsDataDtl,
      saveLineReason,
      fieldValidation,
      htsBasedAvailableCodes,
      updateTradeAgreementListOnCountryChange,
      updateDutyRateOnTradeAgreementChange,
      setHSDTL,
      invoiceItemIndex,
      headerParties,
      invoiceId,
      merchandiseDuties,
      pscData,
      removeDutyItem,
      manufacturerId,
      splPrgList,
    } = this.props

    let countryListCanadaReplacedWithProvinces = countryList || [];
    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
      lineItemIndex = 0;
      invoiceItemIndex = 0;
      countryOfOrigin = this.props.prodHistoryFormData.originCountry;
      productClaimCode = this.props.prodHistoryFormData.productClaimCode;
      splProgramList = this.props.dropdownValues.splProgramList;
      availableProductClaimCode = this.props.dropdownValues.splProgramList;
      manufacturerId = this.props.prodHistoryFormData.manufacturerId;
      isDisabled =  () => {return false}
      grossWeightWeight = get(this.props, 'prodHistoryFormData.grossWeight.weight');
      countryListCanadaReplacedWithProvinces = this.props.dropdownValues.countryList;

    }
    countryListCanadaReplacedWithProvinces= countryListCanadaReplacedWithProvinces.filter((a)=>a.id != "CA");
    countryListCanadaReplacedWithProvinces = countryListCanadaReplacedWithProvinces.concat([
      {id:"XA",description:"Canada: Alberta",ediCode:"XA",},
      {id:"XB",description:"Canada: New Brunswick",ediCode:"XB",},
      {id:"XC",description:"Canada: British Columbia",ediCode:"XC",},
      {id:"XM",description:"Canada: Manitoba",ediCode:"XM",},
      {id:"XN",description:"Canada: Nova Scotia",ediCode:"XN",},
      {id:"XO",description:"Canada: Ontario",ediCode:"XO",},
      {id:"XP",description:"Canada: Prince Edward Island",ediCode:"XP",},
      {id:"XQ",description:"Canada: Quebec",ediCode:"XQ",},
      {id:"XS",description:"Canada: Saskatchewan",ediCode:"XS",},
      {id:"XT",description:"Canada: Northwest Territories",ediCode:"XT",},
      {id:"XV",description:"Canada: Nunavut",ediCode:"XV",},
      {id:"XW",description:"Canada: Newfoundland",ediCode:"XW",},
      {id:"XY",description:"Canada: Yukon Territory",ediCode:"XY",}
    ])

    let formDisabled = this.props.formDisabled;
    if(this.props.enableLineItem === true){
      formDisabled = false;
    }
    const lineIndex = (lineItemIndex + 1).toString().length === 1 ? `00${lineItemIndex + 1}` : (lineItemIndex + 1).toString().length === 2 ? `0${lineItemIndex + 1}` : lineItemIndex + 1
    let manufacturerParties = (headerParties || []).filter((a)=>a.headerPartyType=="MANUFACTURER");
    //     headerId: "1445801259"
    // headerPartyType: "MANUFACTURER"
    // mId: "TEST_MID"
    // name: "DONG GUAN LONG WELTH WOOD CO LTD"
    for(let partyy of manufacturerParties){
      partyy.value = partyy.mId
      partyy.description = partyy.name || "N/A"
    }
    let manfacturerFromPartyTab = manufacturerParties.filter((a)=>a.headerId==manufacturerHeaderIdUnderPartiesTab).pop();

    
    const setTradeProgram = (value,newCountryOfOrigin) => {
      if(this.props.launchFrom === 'PRODUCT_HISTORY'){
        return;
      }
      if(value === "A+" || value === "A*"){
        value = "A"
      }
      

      updateMerchLineItemFeild(
        lineItemIndex, invoiceItemIndex,
        'productClaimCode',
        value
      )
      handleLineItemContextSwitch(lineItemIndex, invoiceItemIndex)

      const myDuty = this.props?.merchandiseItem?.merchandiseDuties?.find(aaa => aaa.isCommodityDuty == 1);
      let merchandiseDutyEv = [
        {
          "enteredValue": myDuty.enteredValue,
          "merchandiseDutyId": myDuty.merchandiseDutyId,
          "isCommodityDuty": myDuty.isCommodityDuty
        }]
      saveDescriptionOfMerchandiseLineItem(
        merchandiseId,
        invoiceId,
        'productClaimCode',
        value,
        myDuty ? { addedParametersx: { merchandiseDuties: merchandiseDutyEv } } : {},
      ).then((responseYT) => {

        const newTradeProgram = productClaimCode !== value;
        for (let iiiii in (this.props.merchandiseItem.merchandiseDuties || [])) {
          let currentDuty = this.props.merchandiseItem.merchandiseDuties[iiiii];
          if (newTradeProgram) {
            this.setState({ settingProgram: true });
            setHSDTL(
              itDate,
              this.props.EntryTypeInfo,
              currentDuty.htsus,
              invoiceItemIndex,
              lineItemIndex,
              iiiii,
              currentDuty.isCommodityDuty,
              false,
              invoiceId,
              merchandiseId,
              newCountryOfOrigin,
              this.props.merchandiseItem,
              false,
              () => {
                this.setState({ settingProgram: false });
              }
            )
          }
          updateDutyRateOnTradeAgreementChange(lineItemIndex, invoiceItemIndex, iiiii, value)
          setTimeout(() => {
            console.log('changedetected saveMerchDutyItem: ');
            saveMerchDutyItem(lineItemIndex, invoiceItemIndex, iiiii, ["dutyRate", "otherRate", "specificRate"])
          }, 1000);
        }
        let fieldId = 'productClaimCode'
        this.validateField(lineItemIndex, fieldId, value)

        setTimeout(() => {
          document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
        }
          , 3000)
      })
    }
    if(!countryOfOrigin)availableProductClaimCode=[];
    let hasOnlyNAasSpecialProgram = availableProductClaimCode && (!availableProductClaimCode.length || availableProductClaimCode[0].id == "NA") && availableProductClaimCode.length<=1;
    return (
      <Grid.Row className={`merchandiseCoRow`} style={{"paddingTop": "0px", "paddingBottom": "0px"}}>
            <Grid.Column className={' ' + (this.props.launchFrom === "PRODUCT_HISTORY" ? ' firstCol no-field-margin down-border ' : ' firstCol no-field-margin ')} width={'3'} style={{"paddingLeft": "0px"}}>
              <UpdateTariffs invoiceId={invoiceId} merchandiseId={merchandiseId}>
                {({updateHTS})=><DropDown
                  style={{"borderBottom":"1px solid #ccc"}}
                  disabled={this.props.enableLineItem === true ? false :  isDisabled('countryOfOrigin')}
                  id={`${lineItemIndex}countryOfOrigin`}
                  label='COUNTRY OF ORIGIN'
                  className='field-bg dropdown100'
                  isLabel={false}
                  text={(displayMasterItem(countryOfOrigin, countryListCanadaReplacedWithProvinces)||"").substring(0,20)}
                  data={countryListCanadaReplacedWithProvinces}
                  errors={fieldValidation?.validObjects_bl[`Merchandiseqwqr${'countryOfOrigin'}${merchandiseId}`]}
                  onChange={async (value)=>{
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("originCountry", value, "0", null)
                      return;
                    }
                    // if(value !=="CN")
                    await updateHTS({countryOfOrigin: value})
                    changeCountryOfOrigin(value,this.props)
                    
                    let chinaExtraDuties = (merchandiseDuties||[]).filter(a=>a.isCommodityDuty==2 && ["99038815","99038803","99038802"].includes((a.htsus||"").replaceAll(".","").trim()));
                    if(value == 'CN' && this.props.merchandiseDuties[0].htsus){
                      if(hsDataDtl?.chinaTariffMetadata){
                        let alreadyApplied = checkIfAlreadyApplied(hsDataDtl?.chinaTariffMetadata, merchandiseId, this.props.merchandiseItem, entryDate);
                        !alreadyApplied && createMerchandiseDutyItem(
                          invoiceItemIndex,
                          invoiceId,
                          merchandiseId,
                          lineItemIndex,
                          function(){},
                          (hsDataDtl?.chinaTariffMetadata.htsNo || "")//.replaceAll(".","")
                          ,
                          null,
                          hsDataDtl.chinaTariffMetadata
                        )
                        }      
                    }else if(countryOfOrigin =="CN" && chinaExtraDuties?.length){//changing from China
                      if(hasanyoverrideflag(merchandiseDuties)){
                        window.alert("WARNING: Can't remove China extra duties because due to override flag! Remove override flag and delete extra duties.")
                      } else {
                        setTimeout(() => {
                          removeDutyItem(
                            merchandiseId,
                            chinaExtraDuties.map(oneduty => oneduty.merchandiseDutyId),
                            lineItemIndex,
                            invoiceItemIndex,
                            0,//unused
                            null,
                            pscData.pscShipmentId
                          )

                          setTimeout(() => {
                            let firsthtscode = document.getElementsByClassName(merchandiseId + "commodityDuty1")[0];
                            firsthtscode && firsthtscode.dispatchEvent(new Event("blur"));
                          }, 300)
                        }, 2502);
                      }
                    }


                    let russiaExtraDuties = (merchandiseDuties || []).filter(a => a.isCommodityDuty == 2 && ["99039008"].includes((a.htsus || "").replaceAll(".", "").trim()));
                    if (value == "RU" && russiaTarriffCodes.find(a=>(this.props.merchandiseDuties[0].htsus+"").startsWith(a))) {
                      if (!checkIfRussiaTarriffAlreadyApplied(this.props.merchandiseItem)) {
                        createMerchandiseDutyItem(
                          invoiceItemIndex,
                          invoiceId,
                          merchandiseId,
                          lineItemIndex,
                          function () { },
                          "99039008",
                          null,
                          {
                            "htsNo": "99039008",
                            displayDescription: "RUSSIA COLUMN 2 INCREASE 3"
                          }
                        )
                      }
                    } else if(countryOfOrigin =="RU" && russiaExtraDuties?.length){//CHANGING FROM RUSSIA
                      
                      if(hasanyoverrideflag(merchandiseDuties)){
                        window.alert("WARNING: Can't remove RUSSIA extra duties because due to override flag! Remove override flag and delete extra duties.")
                      } else {
                        setTimeout(() => {
                          removeDutyItem(
                            merchandiseId,
                            russiaExtraDuties.map(oneduty => oneduty.merchandiseDutyId),
                            lineItemIndex,
                            invoiceItemIndex,
                            0,//unused
                            null,
                            pscData.pscShipmentId
                          )

                          setTimeout(() => {
                            let firsthtscode = document.getElementsByClassName(merchandiseId + "commodityDuty1")[0];
                            firsthtscode && firsthtscode.dispatchEvent(new Event("blur"));
                          }, 300)
                        }, 2502);
                      }
                    }
                    this.setState({settingProgram:true})
                    setTimeout(()=>{
                      let countOfOptionsInNewCountry = document.getElementById(`countofproductclaimCodesFor${merchandiseId}`).value;
                      if(countOfOptionsInNewCountry != 1 || !["NONE","","NA"].includes(productClaimCode) ){
                        setTradeProgram("NONE", value);
                        setTimeout(()=>{
                          document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
                        },100)
                      }
                      if(countOfOptionsInNewCountry == 1 && !["NA"].includes(productClaimCode)){
                        setTradeProgram("NA", value);

                        setTimeout(()=>{
                          document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
                        },100)
                      }
                      this.setState({settingProgram:false})
                    },2000)
                    if(window.lastProgramSetForCountry && window.lastProgramSetForCountry[merchandiseId]){
                      window.lastProgramSetForCountry[merchandiseId] = {};
                    }
                  }}
                  onBlur={(event)=>{
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    let myvalue = (_.get(event,"target.value","")||"").toUpperCase()
                    if(myvalue.length==2){
                      changeCountryOfOrigin(myvalue,this.props)
                      // setTradeProgram("NONE");
                    }
                    
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />}
                </UpdateTariffs>
                {/* {this.displayValidationError(
                  'form.descriptionOfMerchandise.countryOfOrigin'
                )} */}
              </Grid.Column>
              <Grid.Column className={' noLeftBorders '+(this.props.launchFrom === "PRODUCT_HISTORY" ? 'merged secColn no-field-margin down-border' : 'merged secColn no-field-margin')} width={'3'}>
                
              <input type="hidden" value={(availableProductClaimCode||[]).length} id={`countofproductclaimCodesFor${merchandiseId}`}/>
                <span style={{display:'none'}}>
                  {!this.state.settingProgram && 
                  countryOfOrigin && 
                  (["NONE","_BLANK_"].includes(productClaimCode) && hasOnlyNAasSpecialProgram) && (availableProductClaimCode||[]).length &&
                   !(this.props.enableLineItem === true ? false :  isDisabled('productClaimCode')) && (()=>{
                    window.lastProgramSetForCountry = window.lastProgramSetForCountry || {};
                    window.lastProgramSetForCountry[merchandiseId] = window.lastProgramSetForCountry[merchandiseId] || {};
                    if(!window.lastProgramSetForCountry[merchandiseId].country || window.lastProgramSetForCountry[merchandiseId].country != countryOfOrigin + this.props.merchandiseDuties[0].htsus){
                      window.lastProgramSetForCountry[merchandiseId] = {
                        country:countryOfOrigin + this.props.merchandiseDuties[0].htsus,
                        counterxx: Date.now() + 1700,
                      }
                    }          
                    if(window.lastProgramSetForCountry[merchandiseId].counterxx > Date.now())return;
                    window.lastProgramSetForCountry[merchandiseId].counterxx=Date.now() + 7000;
                  setTradeProgram("NA", countryOfOrigin);

                  setTimeout(()=>{
                    document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
                  },100)
                })()}</span>
                <UpdateTariffs  invoiceId={this.props.invoiceId} merchandiseId={merchandiseId}>
                {({updateHTS})=> <DropDown
                  id={`${lineItemIndex}productClaimCode`}
                  disabled={this.state.settingProgram || (hasOnlyNAasSpecialProgram && productClaimCode=="NA")  || (this.props.enableLineItem === true ? false :  isDisabled('productClaimCode'))}
                  errors={(this.state.settingProgram)?[]:fieldValidation?.validObjects_bl[`Merchandiseqwqr${'productClaimCode'}${merchandiseId}`]}
                  label='TRADE AGREE./SPL PRG.'
                  labelIcon={<PopUpIcon icon='info circle' popupText={'Provide a valid HTS # to view applicable Trade Agreement / Special Program Codes'} />}
                  className='field-bg dropdown100'
                  isLabel={false}
                  text={
                    (this.state.settingProgram || availableProductClaimCode.length==0)?"Working...":
                    (productClaimCode == "NA")?"N/A - Not Applicable":
                    ["_BLANK_","NONE"].includes(productClaimCode) ? `Please select [${availableProductClaimCode.map(a=>a.id).join("] [")}]`  :
                    (displayMasterItem(productClaimCode, splPrgList)||"").substring(0,22)}
                  data={availableProductClaimCode}
                  onChange={async (value)=>{
                    await updateHTS({tradeAgreement: value})
                    this.setState({settingProgram:true});
                    setTimeout(()=>{this.setState({settingProgram:false})},2500);
                    setTradeProgram(value);
                  
                  }}
                />}
              </UpdateTariffs>
              </Grid.Column>
              <Grid.Column className={'merged secColn no-field-margin '+(this.props.launchFrom === "PRODUCT_HISTORY" ?' down-border ':' noBottomBorders ')} width={'6'}>
                {this.props.launchFrom !== "PRODUCT_HISTORY" ? <DropDown
                  id={`${lineItemIndex}manufacturerId`}
                  disabled={this.props.launchFrom === '' ? true : (this.props.enableLineItem === true ? false :  isDisabled('manufacturerId'))}
                  errors={fieldValidation?.validObjects_bl[`Merchandiseqwqr${'manufacturerId'}${merchandiseId}`]}
                  label='Manufacturer / MID'
                  labelIcon={<PopUpIcon icon='info circle' popupText={'Add Modify and Remove manufacturers on the Parties Tab'} />}
                  className='field-bg dropdown100 manufacturerBoxCss'
                  isLabel={false}
                  text={(displayDropDownItem((manfacturerFromPartyTab||{}).value, manufacturerParties) || deprecatedManufacturerId)}
                  data={manufacturerParties}
                  onChange={value => {
                    this.changemanufacturer(value,manufacturerParties);
                  }}
                /> : <InputField
                id={`${lineItemIndex}mid`}
                errors={fieldValidation?.validObjects_bl[`Merchandiseqwqr${'mid'}${merchandiseId}`]}
                type={'text'}
                className={'field-bg'}
                label={'MANUFACTURER ID'}
                value={manufacturerId}
                disabled={this.props.enableLineItem === true ? false :  isDisabled('mid')}
                errors={DoMFields['mid'].errors}
                onChange={value => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    this.props.updateFormState("manufacturerId", value, "0", null)
                    return;
                  }
                  updateMerchLineItemFeild(
                    lineItemIndex,
                    "manufacturerId",
                    value
                  );
                  // This does nothing? Commenting
                  //this.callAutosuggestAPI(value.toUpperCase(),"SEARCH_MID_LIST");
                }}
                onBlur={value => {
                  saveDescriptionOfMerchandiseLine(
                    lineItemIndex,
                    "manufacturerId"
                  );
                  setTimeout(()=>{this.setState({showMidList: false})},1000);
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              // clearInput={true}
              />}
              </Grid.Column>
              {/* <Grid.Column className='merged no-field-margin' width={'4'}>
                <InputField
                  id={`${lineItemIndex}mid`}
                  errors={fieldValidation?.validObjects_bl[`Merchandiseqwqr${'mid'}${merchandiseId}`]}
                  type={'text'}
                  className={'field-bg'}
                  label={'MANUFACTURER ID'}
                  value={manufacturerId}
                  disabled={this.props.enableLineItem === true ? false :  isDisabled('mid')}
                  errors={DoMFields['mid'].errors}
                  onChange={value => {
                    updateMerchLineItemFeild(
                      lineItemIndex,
                      "manufacturerId",
                      value
                    );
                    this.callAutosu ggestAPI(value.toUpperCase(),"SEARCH_MID_LIST");
                  }}
                  onBlur={value => {
                    saveDescriptionOfMerchandiseLine(
                      lineItemIndex,
                      "manufacturerId"
                    );
                    setTimeout(()=>{this.setState({showMidList: false})},1000);
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                // clearInput={true}
                />
                  
              {/* </Grid.Column> */}
              <Grid.Column className={'lastCol no-field-margin '+(this.props.launchFrom === "PRODUCT_HISTORY" ?' down-border ':' noBottomBorders ')} width={'4'} style={{"paddingRight": "0px"}}>
                <SelecTextField
                  type='text'
                  id={`${lineItemIndex}grossWeight.weight`}
                  inputName={`${lineItemIndex}grossWeight.weight`}
                  disabled={this.props.launchFrom === "PRODUCT_HISTORY" || 
                   (this.props.enableLineItem === true ? false :  isDisabled('grossWeight.weight'))}
                   label={<>LINE ITEM WEIGHT 
                    {localStorage.getItem("disableAutoCalculate")!='true' && <PopUpIcon basic={true}  icon='info circle' popupText={'Line item weights are automatically recalculated on any Entered Value change'} />}
                    {(grossWeightWeight < ((grossWeightUnits+"").toUpperCase()=="LB"?2.2:1)) && <PopUpIcon basic={true} icon='warning' popupText={'Line item weight cannot be less than 1KG/2.2LB. Value will be rounded up to 1KG in the EDI.'} />}
                    </>}
                  className={'field-bg'}
                  options={['KG', 'LB']}
                  isInteger={true}
                  errors={fieldValidation?.validObjects_bl[`Merchandiseqwqr${'grossWeight'}${merchandiseId}`]}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  divClassName='noBottomBorders'
                  updateValue={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("grossWeight.weight",  value.replace(/[^\d.-]/g, ''), "0", null)
                      return;
                    }
                    updateMerchLineItemObject(
                      lineItemIndex,invoiceItemIndex,
                      'grossWeight',
                      'weight',
                      value.replace(/[^\d.-]/g, '')
                    )
                  }}
                  updateDropDownValue={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("grossWeight.weightUnits", value, "0", null)
                      return;
                    }
                    updateMerchLineItemObject(
                      lineItemIndex,invoiceItemIndex,
                      'grossWeight',
                      'weightUnits',
                      value
                    )
                  }}
                  value={grossWeightWeight}
                  dropDownValue={grossWeightUnits?.toUpperCase()||"None"}
                  onBlur={value => {
                    let fieldId = `grossWeight.weight`;
                    this.validateField(lineItemIndex, fieldId, value)
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    updateMerchLineItemObject(
                      lineItemIndex,invoiceItemIndex,
                      'grossWeight',
                      'weight',
                      parseFloat(grossWeightWeight || 0).toFixed(2)
                    )
                    updateTotalValueAndGrossWeight()
                    saveDescriptionOfMerchandiseLine(
                      lineItemIndex,invoiceItemIndex,
                      'grossWeight'
                    )
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
                {this.displayWeightInkg(grossWeightUnits, grossWeightWeight)}
              </Grid.Column>
            </Grid.Row>
    )
  }
}

const mapStateToProps = (state, props) => {
  if(props.launchFrom === 'PRODUCT_HISTORY'){
    return ({

    }) 
  }
  return {
    invoiceItemIndex: props.invoiceItemIndex,
    lineItemIndex: props.lineItemIndex,
    itDate: state.BOLInfo?.itDate?.epochs,
    entryDate: state.EntryTypeInfo?.summaryDate?.epochs,  
    merchandiseItem: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex],
    merchandiseDuties: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties,
    commercialDescription: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].commercialDescription,
    countryOfOrigin: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].countryOfOrigin,
    permitTypeCode: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].permitTypeCode,
    permitNumber: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].permitNumber,
    productClaimCode: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].productClaimCode,
    countryList: state.DropDownValues.countryList,
    userFeeCodes: state.DropDownValues.userFeeCodes,
    permitTypeCodesList: state.DropDownValues.permitTypeCodesList,
    USStatesList: state.DropDownValues.USStatesList,
    splProgramList: state.DropDownValues.splProgramList,
    htsBasedAvailableCodes: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].htsBasedAvailableCodes || [],
    tradeProgramDetails: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].tradeProgramDetails || [],
    hsDataDtl: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].hsDataDtl,  
    invoiceId: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].invoiceId,
    merchandiseId: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseId,
    isAdCvdApplicable: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0]?.hsDataDtl?.adCvdApplicable,
    mpfFee: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].mpf.fee,
    hmfFee: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].hmf.fee,
    adcvd: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].adcvd,
    IRTax: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].IRTax,
    charges: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].charges,
    otherFee: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].otherFee,
    userFees: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].additionalDuties.userFees,
    manufacturerHeaderIdUnderPartiesTab: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].manufacturerHeaderIdUnderPartiesTab,
    deprecatedManufacturerId: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].manufacturerId,
    weightUnitsList: state.DropDownValues.weightUnitsList,
    splPrgList: state.DropDownValues.splProgramList,
    grossWeightWeight: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].grossWeight.weight,
    grossWeightUnits: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].grossWeight.weightUnits,
    availableProductClaimCode: _.get(state, `DescriptionOfMerchandise.entrySummaryInvoices[${props.invoiceItemIndex}].merchandiseLineItems[${props.lineItemIndex}].availableProductClaimCode`, []),
    unitList: state.DropDownValues.unitList,
    headerParties: state.Importer.headerParties,
    newValue: state.FormValues.newValue,
    fieldName: state.FormValues.fieldName,
    setINPUTID: state.FormValues.setINPUTID,
    penClicked: state.FormValues.penClicked,
    EntryTypeInfo: state.EntryTypeInfo,
    shipmentId: state.FormValues.shipmentId,
    rbCounterID: state.FormValues.rbCounterID,
    formDisabled: state.FormValues.formDisabled,
    fieldValidation: state.FieldValidation,
    pscData: state.PSC
  }
}

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MerchandiseLineItem_co)